import styled from "@emotion/styled";
import { Route } from "react-router-dom";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { authSelector } from "../redux/slices/authSlice";
import {
  getItemizerCodesForToken,
  getItemizerRoute,
  isSpecialItemizerLogin,
} from "../utils/itemizerRules";

import CategoryBar from "../components/CategoryBar";

// Tables
import ReveneuCentar from "../components/tables/ReveneuCentar";
import Itemizer from "../components/tables/Itemizer";
import Category from "../components/tables/Category";
import Payments from "../components/tables/Payments";
import PaymentsSNT from "../components/tables/PaymentsSNT";
import PaymentsCrossPosting from "../components/tables/PaymentsCrossPosting";
import Tax from "../components/tables/Tax";
import Other from "../components/tables/Other";
import Reports from "../components/tables/Reports";
import Log from "../components/tables/Log";

const Wrapper = styled.div`
  padding: 16px;
  padding-top: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const Details = () => {
  const { username, token } = useSelector(authSelector);

  const usePaymentsSnt = useMemo(
    () => String(username || "").startsWith("SNT_"),
    [username]
  );

  const showPaymentsCrossPosting = isSpecialItemizerLogin({ token });
  const itemizerCodes = getItemizerCodesForToken({ token });
  const itemizerRoutes = itemizerCodes.length
    ? itemizerCodes.reduce(
        (routes, code, index) => ({
          ...routes,
          [getItemizerRoute(code, index)]: <Itemizer />,
        }),
        {}
      )
    : { "/details/itemizers": <Itemizer /> };

  const PaymentsComponent = usePaymentsSnt ? PaymentsSNT : Payments;

  const tablesDict = {
      "/details": <ReveneuCentar />,
      ...itemizerRoutes,
      "/details/category": <Category />,
      "/details/payments": <PaymentsComponent />,
      ...(showPaymentsCrossPosting
        ? { "/details/payments-cross-posting": <PaymentsCrossPosting /> }
        : {}),
      "/details/tax": <Tax />,
      "/details/other": <Other />,
      "/details/reports": <Reports />,
      "/details/log": <Log />,
  };

  const tableKeys = Object.keys(tablesDict);

  return (
    <Wrapper>
      <CategoryBar />
      {tableKeys.map((i) => (
        <Route exact path={i} key={i}>
          {tablesDict[i]}
        </Route>
      ))}
    </Wrapper>
  );
};

export default Details;
